<template>
  <div class="header">
    <div class="hea_box">
      <div class="logo">
        <img src="./image/logo3.png" alt="四川大学" />
      </div>
      <div class="Web_title">
          <img src="./image/logoCenter.png" alt="高等教育自学考试" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {}
  }
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 100px;
  background-color: #bb2a17;
  .hea_box {
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    background:url("./image/logoRight_02.jpg") no-repeat top right;
    & > div {
      float: left;
    }
    .logo {
      height: 86px;
      width: 370px;
      margin-top: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .Web_title{
      height: 100px;
      width: 265px;
      margin-left: 180px;
      img{
        padding-top: 35px;
      }
    }
  }
}
</style>
